import { useMemo } from 'react'

export default function useDataTransform(props, data) {
  return useMemo(() => {
    if (!data) return data

    return {
      // only need table data where we have contact details
      first_name: formatEmpty(data.metadata.person?.firstName),
      last_name: formatEmpty(data.metadata.person?.lastName),
      email: formatEmpty(data.metadata.person?.email),
      phone: formatEmpty(data.metadata.person?.phoneDetails?.number),
      fee: formatEmpty(data?.patient?.person?.tx_payers[0]?.tx?.tx_plan?.fee),
      paying: !!data?.patient?.person?.tx_payers[0]?.tx?.tx_plan?.fee,
      conversion: !!data?.patient,
      scheduled: !!data?.patient?.appointments?.[0]?.appointment_bookings?.[0],
      questions: Object.fromEntries(
        data.configuration.questions.map(question => [
          question.id,
          {
            ...question,
            ...question.metadata,
            ...(question.type === 'external'
              ? {
                  ...question?.external_resource,
                  ...question?.external_resource?.metadata,
                  resource: {
                    type: `${question.resource_schema}.${question.resource_table}`,
                    id: question.resource_id,
                  },
                }
              : {}),
          },
        ])
      ),
      ...data,
    }
  }, [data])
}

function formatEmpty(value) {
  return value || '-'
}
